import axios from 'axios'
import apiErrorHandler from '../utils/apiErrorHandler'
import store from '@/store'

async function getCompanyInfos(buyerId=null,providerId) {
    try {
        /**
         * URL Original: /order/companyinfos/${ orderId }
         */
        const result = await axios.get(`${process.env.VUE_APP_ROOT_API}/marketplace/v1/order/companyInfos/?providerId=${providerId} ${(buyerId) ? `&buyerId=${buyerId}`: ``}`, {
            headers: {
                Authorization: `Bearer ${store.state.user.token}`
            }
        })
        return result.data.payload
    } catch(err) {
        apiErrorHandler(err.response)
        return(err.response.status)
    }
}

export default getCompanyInfos

// http://api-cashforce.brazilsouth.cloudapp.azure.com/marketplace/v1/order/companyInfos?buyerId=01&providerId=02